import React, { useEffect, useState } from 'react';
import LoadingAnimation from './LoadingAnimation';

import { useNavigate } from 'react-router-dom';
import { Card } from './ui/card';

/**
 * AuthCallback component
 * 
 * This component is now simplified since we're using Firebase popup auth.
 * It mainly handles edge cases where users land on this URL directly.
 * 
 * With Firebase popup authentication, the auth flow happens entirely in the popup
 * and doesn't require a callback URL redirect.
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    // If someone lands on this page directly, redirect them to login
    // The actual auth flow is handled by Firebase popup in Login.jsx
    const timer = setTimeout(() => {
      navigate('/login', { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <LoadingAnimation size="sm" className="mx-auto" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Redirecionando...
        </h2>
        <p className="text-gray-600">
          Você será redirecionado para a página de login.
        </p>
        {error && (
          <p className="mt-4 text-red-600 text-sm">{error}</p>
        )}
      </Card>
    </div>
  );
};

export default AuthCallback;


